"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEISMIC_DATE_FORMAT = exports.OLD_LANG_CODE_MAPPING_TO_NEW_LANG_CODE = exports.DATE_FORMAT_DEFAULT_WITHOUT_YEAR = exports.DATE_FORMAT_DEFAULT = void 0;
exports.DATE_FORMAT_DEFAULT = 'MMM DD, YYYY';
exports.DATE_FORMAT_DEFAULT_WITHOUT_YEAR = 'MMM DD';
exports.OLD_LANG_CODE_MAPPING_TO_NEW_LANG_CODE = {
    en: 'en-US',
    zh: 'zh-CN',
};
exports.SEISMIC_DATE_FORMAT = {
    'en-US': {
        DATE_FORMAT: 'MMM DD, YYYY',
        DATE_FORMAT_WITHOUT_YEAR: 'MMM DD',
        MOMENT_LOCALE_KEY: 'en',
    },
    'en-GB': {
        DATE_FORMAT: 'DD MMM YYYY',
        DATE_FORMAT_WITHOUT_YEAR: 'DD MMM',
        MOMENT_LOCALE_KEY: 'en-gb',
    },
    'de-DE': {
        DATE_FORMAT: 'DD.MM.YYYY',
        DATE_FORMAT_WITHOUT_YEAR: 'DD.MM',
        MOMENT_LOCALE_KEY: 'de',
    },
    'es-ES': {
        DATE_FORMAT: 'DD MMM YYYY',
        DATE_FORMAT_WITHOUT_YEAR: 'DD MMM',
        MOMENT_LOCALE_KEY: 'es',
    },
    'fr-CA': {
        DATE_FORMAT: 'DD MMM YYYY',
        DATE_FORMAT_WITHOUT_YEAR: 'DD MMM',
        MOMENT_LOCALE_KEY: 'fr-ca',
    },
    'fr-FR': {
        DATE_FORMAT: 'DD MMM YYYY',
        DATE_FORMAT_WITHOUT_YEAR: 'DD MMM',
        MOMENT_LOCALE_KEY: 'fr-ch',
    },
    'it-IT': {
        DATE_FORMAT: 'DD MMM YYYY',
        DATE_FORMAT_WITHOUT_YEAR: 'DD MMM',
        MOMENT_LOCALE_KEY: 'it',
    },
    'ja-JP': {
        DATE_FORMAT: 'YYYY/MM/DD',
        DATE_FORMAT_WITHOUT_YEAR: 'MM/DD',
        MOMENT_LOCALE_KEY: 'ja',
    },
    'ko-KR': {
        DATE_FORMAT: 'YYYY. M. DD.',
        DATE_FORMAT_WITHOUT_YEAR: 'M. DD.',
        MOMENT_LOCALE_KEY: 'ko',
    },
    'pt-BR': {
        DATE_FORMAT: 'DD/MM/YYYY',
        DATE_FORMAT_WITHOUT_YEAR: 'DD/MM',
        MOMENT_LOCALE_KEY: 'pt-br',
    },
    'zh-CN': {
        DATE_FORMAT: 'YYYY年MMMDo',
        DATE_FORMAT_WITHOUT_YEAR: 'MMMDo',
        MOMENT_LOCALE_KEY: 'zh-cn',
    },
    'zh-TW': {
        DATE_FORMAT: 'YYYY年MMMDo',
        DATE_FORMAT_WITHOUT_YEAR: 'MMMDo',
        MOMENT_LOCALE_KEY: 'zh-tw',
    },
    'ru-RU': {
        DATE_FORMAT: 'D.MM.YYYY',
        DATE_FORMAT_WITHOUT_YEAR: 'D.MM',
        MOMENT_LOCALE_KEY: 'ru',
    },
    'id-ID': {
        DATE_FORMAT: 'dd/MM/yyyy',
        DATE_FORMAT_WITHOUT_YEAR: 'dd/MM',
        MOMENT_LOCALE_KEY: 'id',
    },
    'tr-TR': {
        DATE_FORMAT: 'D.MM.YYYY',
        DATE_FORMAT_WITHOUT_YEAR: 'D.MM',
        MOMENT_LOCALE_KEY: 'tr',
    },
    //need product defination
    //format below are from moment's defination: https://seismic.atlassian.net/wiki/spaces/~800277408/pages/2704383090/date-format+from+moment.js
    ar: {
        DATE_FORMAT: 'D/M/YYYY',
        DATE_FORMAT_WITHOUT_YEAR: 'D/M',
        MOMENT_LOCALE_KEY: 'ar',
    },
    'bg-BG': {
        DATE_FORMAT: 'D.MM.YYYY',
        DATE_FORMAT_WITHOUT_YEAR: 'D.MM',
        MOMENT_LOCALE_KEY: 'bg',
    },
    'hr-HR': {
        DATE_FORMAT: 'DD.MM.YYYY',
        DATE_FORMAT_WITHOUT_YEAR: 'DD.MM',
        MOMENT_LOCALE_KEY: 'hr',
    },
    'cs-CZ': {
        DATE_FORMAT: 'DD.MM.YYYY',
        DATE_FORMAT_WITHOUT_YEAR: 'DD.MM',
        MOMENT_LOCALE_KEY: 'cs',
    },
    'da-DK': {
        DATE_FORMAT: 'DD.MM.YYYY',
        DATE_FORMAT_WITHOUT_YEAR: 'DD.MM',
        MOMENT_LOCALE_KEY: 'da',
    },
    'et-EE': {
        DATE_FORMAT: 'DD.MM.YYYY',
        DATE_FORMAT_WITHOUT_YEAR: 'DD.MM',
        MOMENT_LOCALE_KEY: 'et',
    },
    'fi-FI': {
        DATE_FORMAT: 'DD.MM.YYYY',
        DATE_FORMAT_WITHOUT_YEAR: 'DD.MM',
        MOMENT_LOCALE_KEY: 'fi',
    },
    'el-GR': {
        DATE_FORMAT: 'DD/MM/YYYY',
        DATE_FORMAT_WITHOUT_YEAR: 'DD/MM',
        MOMENT_LOCALE_KEY: 'el',
    },
    'hu-HU': {
        DATE_FORMAT: 'YYYY.MM.DD.',
        DATE_FORMAT_WITHOUT_YEAR: 'MM.DD.',
        MOMENT_LOCALE_KEY: 'hu',
    },
    'lt-LT': {
        DATE_FORMAT: 'YYYY-MM-DD',
        DATE_FORMAT_WITHOUT_YEAR: 'MM-DD',
        MOMENT_LOCALE_KEY: 'lt',
    },
    'pl-PL': {
        DATE_FORMAT: 'DD.MM.YYYY',
        DATE_FORMAT_WITHOUT_YEAR: 'DD.MM',
        MOMENT_LOCALE_KEY: 'pl',
    },
    'ro-RO': {
        DATE_FORMAT: 'DD.MM.YYYY',
        DATE_FORMAT_WITHOUT_YEAR: 'DD.MM',
        MOMENT_LOCALE_KEY: 'ro',
    },
    'sk-SK': {
        DATE_FORMAT: 'DD.MM.YYYY',
        DATE_FORMAT_WITHOUT_YEAR: 'DD.MM',
        MOMENT_LOCALE_KEY: 'sk',
    },
    'sv-SE': {
        DATE_FORMAT: 'YYYY-MM-DD',
        DATE_FORMAT_WITHOUT_YEAR: 'MM-DD',
        MOMENT_LOCALE_KEY: 'sv',
    },
};
//# sourceMappingURL=DateFormat.js.map